import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { environment } from 'src/environments/environment';
import { Acreditacion } from 'src/app/models/administracion/acreditacion.model';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AcreditacionService extends BaseService {
    override recordName = 'acreditaciones';

    override url = `${environment.host}/acreditacion`;

    override codigoRegistro = Acreditacion.CODIGO_REGISTRO;

    private _acreditacion: Record<string, any> | null;

    set acreditacion(acreditacion: Record<string, any> | null) {
        this._acreditacion = acreditacion;
    }

    get acreditacion() {
        return this._acreditacion;
    }

    // async controlarAcreditacionAutogestion( body?: Record<string, any>) {
    //     let url = `${this.url}/controlar-acreditacion-autogestion`;
    //     try {
    //         await this.updateToken();
    //         const headers = this.header;
    //         const resp = await lastValueFrom(this.http.post<any>(url, body, { headers: headers }));
    //         return resp;
    //     } catch (error: any) {
    //         return this.checkError( error );
    //     }
    // }
}
